import { getFeatureFlagValue } from 'new/constants/featureFlags';

/**
 * Opt-in header for admin-api's server-side OAuth.
 *
 * Sending it tells the API that this client does not run the OAuth dance itself, so the API
 * strips the hidden parameters it will resolve server-side (`OauthParamFilter`). The API only
 * strips for three-legged templates, so the header is safe to send on any auth-parameter read.
 *
 * It must go on **every** request whose response carries `auth_parameters` — not just
 * `/auth_parameters`. The expanded vendor read (`/vendors?vendor_name=…&expand=1`) delivers them
 * inline through `auth_templates`, and is the only source of them for templatized-API connectors.
 * Omitting it there leaves those connectors unfiltered regardless of the flag.
 */
export const serverOAuthHeaders = (): Record<string, string> | undefined =>
  getFeatureFlagValue('UI_OAUTH_SERVER_FLOW') ? { 'X-Nexla-Server-OAuth': 'true' } : undefined;
